import { render, staticRenderFns } from "./RegisterStep5.vue?vue&type=template&id=deccf2de&"
import script from "./RegisterStep5.vue?vue&type=script&lang=js&"
export * from "./RegisterStep5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports